import { render, staticRenderFns } from "./crm-manage-tag-tab.vue?vue&type=template&id=51cd9078&scoped=true&"
import script from "./crm-manage-tag-tab.vue?vue&type=script&lang=js&"
export * from "./crm-manage-tag-tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51cd9078",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/home/application/eu/trade-dsm-frontend_2022/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51cd9078')) {
      api.createRecord('51cd9078', component.options)
    } else {
      api.reload('51cd9078', component.options)
    }
    module.hot.accept("./crm-manage-tag-tab.vue?vue&type=template&id=51cd9078&scoped=true&", function () {
      api.rerender('51cd9078', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/trade-crm-app/rfi_process/tabs/manage-tags/crm-manage-tag-tab.vue"
export default component.exports